import { Tabs, Row, Col } from 'antd';
import { HomeSvg, StickyNoteSvg } from '@/assets/icons';
import FamilyStatus from '../family-status';
import FamilyNotes from '../family-notes';

const FamilyTabsView = ({ parentId, permissions }) => {
  const TabTitle = ({ icon, title }) => (
    <span style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '15px' }}>
      {icon}
      {title}
    </span>
  );

  const tabItems = [
    {
      label: <TabTitle icon={<HomeSvg />} title="Family Status" />,
      key: '1',
      children: (
        <div style={{ marginLeft: '-20px' }}>
          <FamilyStatus parentId={parentId} permissions={permissions} />
        </div>
      ),
    },
    {
      label: <TabTitle icon={<StickyNoteSvg />} title="Family Notes" />,
      key: '2',
      children: (
        <div style={{ marginLeft: '-20px' }}>
          <FamilyNotes parentId={parentId} permissions={permissions} />
        </div>
      ),
    },
  ];

  return (
    <div style={{ backgroundColor: 'white' }}>
      <Row gutter={16}>
        <Col span={24}>
          <Tabs defaultActiveKey="1" style={{ marginLeft: '20px', marginTop: '5px' }} items={tabItems} />
        </Col>
      </Row>
    </div>
  );
};

export default FamilyTabsView;
